export const parseCampaignStatus = status => {
  const textStatus = {
    sent: "sent on",
    active: "SCHEDULED DELIVERY DATE",
    cancelled: "Cancelled on"
  };
  return textStatus[status];
};
export const campaignIsSent = status => status !== "sent" ? "disabled" : "";
export const registerHandlebarHelpers = Handlebars => {
  Handlebars.registerHelper("parseCampaignStatus", parseCampaignStatus);
  Handlebars.registerHelper("campaignIsSent", campaignIsSent);
};